export const getLessonsFromAPI = async (lessons) => {
  const response = await fetch(
    `${process.env.NEXT_PUBLIC_KUNDUZ_API_URL}/v2/library/course-tests/?test_name=${lessons}`,
    {
      headers: new Headers({
        "KZ-COUNTRY-ISO-CODE": "TR",
      }),
    }
  );
  const data = await response.json();

  return data;
};

export const calculateExamScoreViaAPI = async (examData) => {
  const response = await fetch(
    `${process.env.NEXT_PUBLIC_KUNDUZ_API_URL}/v2/library/course-tests/calculate-score/`,
    {
      headers: {
        "Content-Type": "application/json",
      },
      method: "POST",
      body: JSON.stringify(examData),
    }
  );
  const data = await response.json();

  return data;
};

export const sendRequestSmsAPI = async (phoneNumber, link_key) => {
  const response = await fetch(
    `${process.env.NEXT_PUBLIC_KUNDUZ_API_URL}/accounts/dl-link-sms-lp/`,
    {
      method: "POST",
      body: JSON.stringify({
        country: 1,
        number: phoneNumber,
        link_key,
      }),
      headers: {
        "Content-Type": "application/json",
        "Accept-Language": "tr",
      },
    }
  );

  return response;
};
